<!--/* eslint-disable */-->
<template>
  <div>
    <div v-if="complianceServiceType === 'MANUAL'" class="flex gap-4 items-center">

      <div>
        <vs-button
          class="bg-primary"
          :disabled="companyGuid == null"
          @click="validate">Cadastrar</vs-button>
      </div>

      <div>
        <date-picker
          v-model="scoreForm.date"
          name="data"
          v-validate="'required'"
          :append-to-body="false"
          class="w-full z-index-bg"
          :disabled-date="disabledAfterToday"/>
      </div>

      <div>
        <vs-select
          v-model="scoreForm.score"
          name="valor"
          class="w-full">
          <vs-select-item :key="index" :value="score.score" :text="score.description" v-for="(score, index) in complianceValues" />
        </vs-select>
      </div>

    </div>

    <div v-if="complianceServiceType === 'AUTOMATIC'" class="flex gap-4 items-center">
      <vs-checkbox
        v-model="requestComplianceReport">
        <span style="font-size: 14px; font-weight: bold">Requisitar novo relatório de compliance</span>
      </vs-checkbox>
    </div>

    <div v-if="complianceServiceType != null">
      <vs-table
        stripe
        v-model="selected"
        :data="scores"
        @selected="handleComplianceSelected"
        class="mt-4"
        noDataText="Não há valores cadastrados para esta empresa.">

        <template slot="thead">
          <th></th>
          <th>Data</th>
          <th>Nota</th>
          <th>Apagar</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-show="!requestComplianceReport" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              <vs-checkbox
                v-model="data[indextr].checked"
                disabled="true"
              />
            </vs-td>
            <vs-td :data="data[indextr].date">
              {{tr.date | formatDate}}
            </vs-td>
            <vs-td :data="data[indextr].value">
              <span v-if="tr.value != null">{{tr.value}}</span>
              <span v-else-if="tr.description != null">{{tr.description}}</span>
              <span v-else>Sem Nota</span>
            </vs-td>
            <vs-td><span role="button" style="cursor: pointer; color: blue" @click="deleteScore(tr)">Apagar Nota</span></vs-td>
          </vs-tr>
        </template>

      </vs-table>

    </div>
  </div>

</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import moment from 'moment'
import NumericInput from './NumericInput'

export default {
  name: 'ComplianceForm',
  props: {
    companyGuid: String,
  },
  watch: {
    nullScore() {
      if (this.nullScore === true) {
        this.scoreForm.value = null
        this.convertSerasa = false
      }
    },

    companyGuid() {
      this.getValues()
    },

    requestComplianceReport(newVal) {
      if (newVal === true) {
        this.selected = null
      }
    },
  },
  components: {
    DatePicker,
    moment,
    NumericInput
  },
  mounted () {
    this.getComplianceValues()
  },
  beforeMount() {
    this.complianceService()
  },
  data () {
    return {
      complianceServiceType: 'MANUAL',
      requestComplianceReport: false,
      selected: null,
      nullScore: false,
      convertSerasa: false,
      scoreForm: {
        companyGuid: null,
        date: null,
        value: null
      },
      score: {
        company: {
          guid: null
        },
        date: null,
        value: null
      },
      scores: [],
      complianceValues: [],
      sectorAnalysisValues: []
    }
  },
  methods: {
    complianceService() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant/role`, {
        params: {
          role: 'COMPLIANCE'
        }
      })
      .then((response) => {
        this.complianceServiceType = response.data.type
      })
    },

    disabledAfterToday (date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },

    getComplianceValues() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/compliance/values`)
        .then((response) => {
          this.complianceValues = response.data
        })
    },

    getSelected() {
      return this.selected
    },

    getRequestReport() {
      return this.requestComplianceReport
    },

    getValues () {
      if (this.companyGuid == null) return

      this.scoreForm.companyGuid = this.companyGuid
      axios.get(`${process.env.VUE_APP_API}/api/v1/compliance/${this.companyGuid}`)
        .then((response) => {
          this.scores = response.data
          for (let i = 0; i < this.scores.length; i++) {
            this.scores[i].checked = false
          }
        })

    },

    validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setValue()
        } else {
          for (const idx in this.errors.items) {
            this.$vs.notify({
              color: 'danger',
              text: this.errors.items[idx].msg
            })
          }
        }
      })
    },

    setValue () {
      if (this.companyGuid == null) {
        this.$vs.notify({
          color: 'danger',
          text: 'Selecione um garantidor.'
        })
        return
      }

      this.scoreForm.companyGuid = this.companyGuid
      axios.post(`${process.env.VUE_APP_API}/api/v1/compliance`, this.scoreForm)
        .then((response) => {
          this.scores = response.data
        })
        .finally(() => {
          this.getValues()
        })
    },

    deleteScore(tr) {
      axios.delete(`${process.env.VUE_APP_API}/api/v1/compliance/` + tr.guid)
        .then((response) => {
          this.scores = response.data
        })
        .finally(() => {
          this.getValues()
        })
    },

    handleComplianceSelected (tr) {
      for (let i = 0; i < this.scores.length; i++) {
        this.scores[i].checked = tr.guid === this.scores[i].guid;
      }
    },

  }
}
</script>

<style scoped>
.z-index-bg {
  z-index: 500;
}
</style>
